import { Col, Row } from 'react-grid-system'
import styled from 'styled-components'
import { ImageUploader, VideoUploader } from '../molecules'
import { useCreatePropertyContext, useUserLanguage } from '@/customHooks'
import textsData from '@/textData/CreatePropertyTexts.json'

const FieldContainer = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.border.radius.lg};
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  min-width: 360px;
  width: 550px;
`

export const SelectPropertyImagesForm = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.propertyImages : textsData.en.propertyImages

  const { setPictures, setVideos, setButtonEnabled } = useCreatePropertyContext()

  const onPicturesReadyHandle = (pictures: File[]) => {
    setPictures(pictures)
    setButtonEnabled()
  }

  const onVideosReadyHandle = (videos: File[]) => {
    setVideos(videos)
    setButtonEnabled()
  }

  return (
    <Row justify="center">
      <Col xs="content">
        <FieldContainer>
          <h3>{texts.title}</h3>
          <p>{texts.description}</p>
          <ImageUploader onUploadReady={onPicturesReadyHandle}/>
          <VideoUploader onUploadReady={onVideosReadyHandle}/>
        </FieldContainer>
      </Col>
    </Row>
  )
}
